import React, { useContext } from "react";
import { FacebookProvider, Login } from "react-facebook";
import path from "path";
import { FLR } from "../../../../../Types";
import { AppContext } from "../../../../../provider/AppProvider";
import { fetchApi } from "../../../../../config/core/Api";
import { AxiosResponse } from "axios";
import BrowserStorage from "../../../../../config/core/BrowserStorage";

interface FBLoginBtnProps {
  onClick: any;
}

interface LongLivedAccessTokenResponse {
  access_token: string;
  expires_in: number;
  token_type: "bearer";
}

function FBLoginBtn({ onClick }: FBLoginBtnProps): JSX.Element {
  let t = window.INITIAL_DATA.TRANSLATIONS;
  const { facebookResponseData: frd, setFacebookResponseData } = useContext(
    AppContext
  );

  function responseFacebook(response: FLR) {
    if (!frd) {
      if (response.profile && response.tokenDetail) {
        fetchApi({
          method: "POST",
          fullUrl: `${window.location.origin}${window.woocommerce_params.ajax_url}?action=facebook_authentication`,
          data: {
            fb_exchange_token: response.tokenDetail.accessToken,
          },
        })
          .then((r: AxiosResponse<LongLivedAccessTokenResponse>) => {
            let tempData = {
              ...response,
              tokenDetail: {
                ...response.tokenDetail,
                accessToken: r.data.access_token,
                expiresIn: r.data.expires_in,
                type: r.data.token_type,
                data_access_expiration_time:
                  Math.round(+new Date() / 1000) + r.data.expires_in,
              },
            };
            BrowserStorage.setFbAuthData(
              JSON.stringify({
                profile: {
                  id: response.profile.id,
                  first_name: response.profile.first_name,
                  last_name: response.profile.last_name,
                },
                tokenDetail: {
                  accessToken: r.data.access_token,
                  expiresIn: r.data.expires_in,
                  type: r.data.token_type,
                  data_access_expiration_time:
                    Math.round(+new Date() / 1000) + r.data.expires_in,
                },
              })
            );
            setFacebookResponseData({ ...tempData });
          })
          .catch((e) => {
            window.globalToast({
              type: "error",
              title: t.error,
              description: t.something_went_wrong_instagram,
            });
          })
          .finally(() => {});
      } else {
        setFacebookResponseData(null);
      }
    } else if (
      new Date(frd.tokenDetail.data_access_expiration_time * 1000) > new Date()
    ) {
      setFacebookResponseData(response);
    }
  }

  return (
    <FacebookProvider appId="688359145061989">
      <Login
        scope="email"
        onCompleted={responseFacebook}
        onError={(error) => {
          console.log(error);
        }}>
        {({ loading, handleClick, error, data }) => (
          <button
            id={"facebook-collapse-btn"}
            className={"btn product-canvas__btn-wide mb-2"}
            type={"button"}
            onClick={(e) => {
              onClick();
              if (!frd) {
                handleClick(e);
              } else if (
                frd &&
                frd.tokenDetail.data_access_expiration_time <
                  Math.round(+new Date() / 1000)
              ) {
                handleClick(e);
              }
            }}
            disabled={loading}>
            <img
              src={path.resolve(`${window.basePath}/images/facebook.svg`)}
              alt={""}
            />
            <p>Facebook</p>
          </button>
        )}
      </Login>
    </FacebookProvider>
  );
}

export default FBLoginBtn;
